import { Component, OnInit, Input, NgZone } from "@angular/core";
import { blobToBase64String, base64StringToBlob } from "blob-util";
import { HttpEvent } from "@angular/common/http";
import { GeneralService } from "../services/general.service";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { ShowModelComponent } from "../show-model/show-model.component";
import { Router } from "@angular/router";
declare var $: any;
@Component({
  selector: "app-show-tree-doc",
  templateUrl: "./show-tree-doc.component.html",
  styleUrls: ["./show-tree-doc.component.scss"],
})
export class ShowTreeDocComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private ngZone: NgZone,
    public generalService: GeneralService
  ) {}
  listePdfBase64 = [];
  postUrl = "...";
  myFormData: FormData; //populated by ngfFormData directive
  httpEvent: HttpEvent<any>;
  treeDoc = [];
  showDoc = false;
  static selectedNode;
  IdNodeSelected = null;
  clickMode;
  exist = true;
  docBrut;
  curentId = "20000000";
  myDoc;
  categorie;
  buttonDisabled = false;
  nodeSelected;
  @Input() typeTrs = "1";
  @Input() param_code = "";
  // pour identifier le type sur qu'elle module en travaille: collaborateur, action,...
  @Input() File_Type = "";
  // pour identifier le type de ficher :cv , fiches de paie,contrat...
  @Input() File_Groupe = "";
  @Input() showAllDocument = true;
  @Input() File_Lien = "";
  txtFrancais: string;
  txtAnglais: string;
  dsLanguage;
  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else {
      console.log(123);

      this.getDocument(true);
      this.getInitDoc();
      if (this.typeTrs == "3") this.buttonDisabled = true;
    }
  }
  getInitDoc() {
    this.generalService
      .rechercheTable(this.generalService.urlcategorie)
      .subscribe((data) => {
        this.categorie = data;
      });
  }
  onChangefileToUpload(fileInput) {
    blobToBase64String(fileInput.target.files[0]).then((base64String) => {
      var parent = "";
      if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
        parent = this.IdNodeSelected;
      }
      this.addFiles(
        this.categorie,
        base64String,
        fileInput.target.files[0].name,
        this.param_code,
        this.File_Type,
        parent,
        this.clickMode,
        this.File_Groupe,
        this.File_Lien
      );
    });
  }
  initTree(addEvent) {
    $("#documentColl").jstree({
      //"plugins" : ["checkbox" ],
      themes: { stripes: true },
      core: {
        strings: {
          "New node": " ",
        },
        check_callback: (operation, node, parent, position, more) => {
          if (operation === "copy_node" || operation === "move_node") {
            if (parent.id === "#") {
              return false;
            }
          } else if (operation === "create_node") {
            //node.icon = "jstree-file";
            //node.id = this.curentId;
            var myNode = $("#documentColl").jstree(true)._model.data[parent.id];
            myNode.icon = true;
          }
          return true;
        },
      },
    });
    $("#documentColl").jstree(true).settings.core.data = this.treeDoc;
    $("#documentColl").jstree(true).refresh();
    if (addEvent) this.addEventTree();
  }
  async openDoc() {
    var node = $("#documentColl").jstree(true).get_node(this.IdNodeSelected);
    if (node.icon == "jstree-file" && node.text.indexOf(".pdf") >= 0) {
      this.exist = false;
      const contentType = "application/pdf";
      const b64Data = await this.generalService
        .rechercheTable(
          this.generalService.urlFiles + "&val=" + this.IdNodeSelected
        )
        .toPromise();
      const blob = base64StringToBlob(
        b64Data.Files[0].File_Content,
        contentType
      );
    } else
      this.generalService.dialogSuccess(
        "Uniquement les fichiers de type PDF peuvent être ouvert",
        false
      );
  }
  // addFile est la meme que la fontion addFile de generale servive sauf-qu'il appelle la fonction this.getDocument(false);
  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien
  ) {
    var doc = this.generalService.clone(initDoc);
    if (clickMode != "renommer") {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Content = File_Content;
      doc.files[0].File_Text = File_Text;
      doc.files[0].File_Key = File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;

      this.generalService.enregisterTable(doc).subscribe(
        (data) => {
          this.getDocument(false);
          this.generalService.dialogSuccess("Document enregisté", true);
        },
        (err) => {
          this.generalService.dialogSuccess("Document non enregisté", false);
        }
      );
    }
  }
  editFiles() {}
  getLangue() {
    try {
      this.generalService
        .rechercheTable(
          "recherche/tbdata?tablere=Lg&param=0," + this.IdNodeSelected
        )
        .subscribe((data) => {
          if (data.length > 0) this.txtFrancais = data[0].Lg_Libelle;
          else this.txtFrancais = "";
        });
      this.generalService
        .rechercheTable(
          "recherche/tbdata?tablere=Lg&param=1," + this.IdNodeSelected
        )
        .subscribe((data) => {
          if (data.length > 0) this.txtAnglais = data[0].Lg_Libelle;
          else this.txtAnglais = "";
        });
    } catch {}
  }
  addEventTree() {
    $("#documentColl").on("select_node.jstree", (e, data) => {
      if (this.IdNodeSelected == data.selected[0]) {
        data.instance.deselect_node(data.node);
        this.IdNodeSelected = null;
        this.File_Groupe = "";
      } else {
        var myNode = data.selected[0];
        this.IdNodeSelected = data.node.a_attr.myId;
        this.nodeSelected = data.node;
        this.File_Groupe = data.node.a_attr.groupe;
        this.getLangue();
        this.txtFrancais = data.node.text;
      }
    });
    $("#documentColl").on("rename_node.jstree", (e, data) => {
      if (data.text != " " && data.text != "") {
        if (this.clickMode == "crerDossier") {
          var maxId = this.docBrut.reduce(function (max, x) {
            return parseInt(x.categorie_Code) > max
              ? parseInt(x.categorie_Code)
              : max;
          }, 0);
          if (this.IdNodeSelected != null) {
            this.enregister({
              categorie_Code: maxId + 1,
              categorie_Text: data.node.text,
              categorie_CodeP: this.IdNodeSelected,
            });
          } else {
            this.enregister({
              categorie_Code: maxId + 1,
              categorie_Text: data.node.text,
              categorie_CodeP: null,
            });
          }
        } else {
          this.updateText(data.node.a_attr.myId, data.node.text);
        }
        //this.generalService.editFiles(data.node)
      } else {
        var MyTree = $("#documentColl").jstree(true);
        MyTree.delete_node(data.node);
      }
    });
    $("#documentColl").on("ready.jstree", (e, data) => {
      var id = 0;
      var theTree = data.instance._model.data;
      for (var prop in theTree) {
        if (theTree[prop].parent == "#") id = theTree[prop].id;
      }
      $("#documentColl").jstree("open_node", $("#" + id));
    });
  }
  capitaliseText(value) {
    value = value.toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  updateText(File_Id, File_Text) {
    this.generalService
      .rechercheTable(this.generalService.urlcategorie + "&val=" + File_Id)
      .subscribe((cat) => {
        cat.ecArtCat[0].categorie_Text = File_Text;
        this.updateDB(cat);
      });
  }
  //elle doit retourne le dernier id du tree (select max(id) as maxId from treeTable)
  getNextId() {
    var listId = this.docBrut.map((t) => parseInt(t.File_Id));
    var max = listId.reduce(function (a, b) {
      return Math.max(a, b);
    });
    return max + 1;
  }
  getChildrenId(id: Number) {
    var list = this.treeDoc.filter((node) => {
      return node.parent == id;
    });
    return list;
  }
  getNodeById(id) {
    var myNode = this.docBrut.find((node) => {
      return node.File_Id == id;
    });
    return myNode;
  }
  getDocument(addEvent) {
    var url = "";
    url = this.generalService.urlListeCategorie;
    this.generalService.rechercheTable(url).subscribe((data) => {
      data.forEach((element) => {
        element.categorie_Text = this.capitaliseText(element.categorie_Text);
      });
      this.docBrut = data;
      this.treeDoc = this.generalService.generateTreeData(this.docBrut);

      this.initTree(addEvent);
      this.showDoc = true;
    });
  }
  crerDossier() {
    this.clickMode = "crerDossier";
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      var MyTree = $("#documentColl").jstree(true);
      var idNode = MyTree.create_node(this.IdNodeSelected, { text: " " });
      MyTree.edit(idNode);
    } else {
      if (this.treeDoc.length == 0) {
        var MyTree = $("#documentColl").jstree(true);
        var id = MyTree.create_node(null, {
          children: [],
          children_d: [],
          data: null,
          icon: true,
          a_attr: { myId: null },
          original: {
            text: "Nouveau dossier",
            icon: "../assets/images/repo.png",
            a_attr: { myId: null },
          },
          parent: null,
          parents: ["#"],
          state: {
            loaded: true,
            opened: true,
            selected: true,
            disabled: false,
          },
          text: "Nouveau dossier",
        });
        MyTree.edit(id);
      } else {
        var MyTree = $("#documentColl").jstree(true);
        var id = MyTree.create_node("#", {
          children: [],
          children_d: [],
          data: null,
          icon: true,
          a_attr: { myId: null },
          original: {
            text: "Nouveau dossier",
            icon: "../assets/images/repo.png",
            a_attr: { myId: null },
          },
          parent: "#",
          parents: ["#"],
          state: {
            loaded: true,
            opened: true,
            selected: true,
            disabled: false,
          },
          text: "Nouveau dossier",
        });
        MyTree.edit(id);
      }
    }
  }
  renommer() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      this.clickMode = "renommer";
      var MyTree = $("#documentColl").jstree(true);
      var pos: number = this.nodeSelected.text.indexOf("<");
      if (pos >= 0)
        this.nodeSelected.text = this.nodeSelected.text.substring(0, pos);
      MyTree.edit(this.IdNodeSelected);
    } else {
      this.generalService.dialogSuccess(
        "veuillez sélectionner un element",
        false
      );
    }
  }

  setIconTree() {
    this.treeDoc.forEach((doc) => {
      var childrens = this.getChildrenId(doc.a_attr.myId);
      if (childrens.length == 0) {
        doc["icon"] = "jstree-file";
      }
    });
  }
  enregister(categorie) {
    this.categorie.ecArtCat[0].categorie_Code = this.generalService.clone(
      categorie.categorie_Code
    );
    this.categorie.ecArtCat[0].categorie_Text = this.generalService.clone(
      categorie.categorie_Text
    );
    this.categorie.ecArtCat[0].categorie_CodeP = this.generalService.clone(
      categorie.categorie_CodeP
    );
    this.updateDB(this.categorie);
  }
  updateDB(ds) {
    console.log("new ds");
    console.log(ds);
    this.generalService.enregisterTable(ds).subscribe(
      (data) => {
        this.generalService.dialogSuccess("Catégorie enregister", true);
        this.getDocument(false);
      },
      (err) => {
        this.generalService.dialogSuccess("Catégorie non enregisté", false);
      }
    );
  }
  addModele() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.autoFocus = true;
      // dialogConfig.width = "50%";
      // dialogConfig.height = "80%";
      this.ngZone
        .run(() => this.dialog.open(ShowModelComponent, dialogConfig))
        .afterClosed();
      var dialogRef = this.dialog.open(ShowModelComponent, dialogConfig);

      dialogRef.afterClosed().subscribe((categorieModelSelected) => {
        if (
          categorieModelSelected != undefined &&
          categorieModelSelected != null &&
          categorieModelSelected != ""
        ) {
          this.generalService
            .rechercheTable(
              this.generalService.urlcategorie + "&val=" + this.IdNodeSelected
            )
            .subscribe(
              (data) => {
                data.ecArtCat[0].ecArtCarMod_Id =
                  categorieModelSelected.ecArtCarMod_Id;
                this.generalService.enregisterTable(data).subscribe(
                  (c) => {
                    this.generalService.dialogSuccess(
                      "Catégorie enregisté",
                      true
                    );
                    this.getDocument(false);
                  },
                  (err) => {
                    this.generalService.dialogSuccess(
                      "Catégorie non enregisté",
                      false
                    );
                  }
                );
              },
              (err) => {
                this.generalService.dialogSuccess(
                  "Catégorie non enregisté",
                  false
                );
              }
            );
        }
      });
    } else
      this.generalService.dialogSuccess(
        "veuillez sélectionner un element",
        false
      );
  }
  supprimerModel() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      // if(this.generalService.userConnecter == "admin")
      // {
      if (confirm("Vouler vous supprimer cette elément")) {
        /* si on clique sur ok */
        this.generalService
          .rechercheTable(
            this.generalService.urlcategorie + "&val=" + this.IdNodeSelected
          )
          .subscribe(
            (data) => {
              data.ecArtCat[0].ecArtCarMod_Id = -1;
              this.generalService.enregisterTable(data).subscribe(
                (c) => {
                  this.generalService.dialogSuccess("Modél supprimer", true);
                  this.getDocument(false);
                },
                (err) => {
                  this.generalService.dialogSuccess(
                    "Modél non supprimer",
                    false
                  );
                }
              );
            },
            (err) => {
              this.generalService.dialogSuccess("Modél non supprimer", false);
            }
          );
      }
      // }
      // else
      this.generalService.dialogSuccess(
        "vous n'avez pas le droit de suppression",
        false
      );
    } else
      this.generalService.dialogSuccess(
        "veuillez sélectionner un element",
        false
      );
  }
  supprimer() {
    if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
      // if(this.generalService.userConnecter == "admin")
      // {
      if (confirm("Vouler vous supprimer cette elément")) {
        /* si on clique sur ok */
        var MyTree = $("#documentColl").jstree(true);
        var node = MyTree.get_node(this.IdNodeSelected);
        this.deleteNode(node.id);
      }
      // }
      // else
      //   this.generalService.dialogSuccess("vous n'avez pas le droit de suppression",false)
    } else {
      this.generalService.dialogSuccess(
        "veuillez sélectionner un element",
        false
      );
    }
  }
  deleteNode(id: string) {
    this.generalService.supprimerSanMsgConfirm(id, "ecartcat").subscribe(
      (data) => {
        this.generalService.dialogSuccess("Elément supprimer", true);
        this.treeDoc = this.treeDoc.filter((node) => {
          return node.id != id;
        });
        var valideNodeAfterDelet = this.generalService.enleverNodeErroner(
          this.treeDoc
        );
        var nodeToDelet = [];
        this.treeDoc.forEach((node) => {
          if (
            valideNodeAfterDelet.find((valideNode) => {
              return valideNode.id == node.id;
            }) == undefined
          )
            nodeToDelet.push(node);
        });
        for (let i = 0; i < nodeToDelet.length; i++) {
          this.generalService
            .supprimerSanMsgConfirm(nodeToDelet[i].id, "ecartcat")
            .subscribe((data) => {});
        }
        this.treeDoc = valideNodeAfterDelet;
        this.initTree(false);

        // suppression image categorie
        this.generalService
          .rechercheTable(
            this.generalService.urlListeFilesR2 +
              "imagesCategories" +
              "," +
              "categorie"
          )
          .subscribe((img) => {
            nodeToDelet.push({ id });
            for (let i = 0; i < nodeToDelet.length; i++) {
              var image = img.filter((im) => {
                return (
                  (";" + im.File_Key).indexOf(";" + nodeToDelet[i].id + "_") >
                  -1
                );
              });
              for (let j = 0; j < image.length; j++) {
                this.generalService
                  .supprimerSanMsgConfirm(image[j].File_Id, "avtFiles")
                  .subscribe((data) => {
                    this.generalService.dialogSuccess(
                      "Elément supprimer",
                      true
                    );
                  });
              }
            }
          });
      },
      (error) => {
        this.generalService.dialogSuccess("Elément non supprimé", false);
      }
    );
  }
  enregistrerLangue() {
    try {
      if (
        this.generalService.isNotEmpty(this.txtAnglais) &&
        this.generalService.isNotEmpty(this.txtFrancais)
      ) {
        if (this.IdNodeSelected != null && this.IdNodeSelected != undefined) {
          this.updateText(this.IdNodeSelected, this.txtFrancais);
          for (let i = 0; i < 2; i++) {
            this.generalService
              .rechercheTable(
                "recherche/tbdata?tablere=Lg&param=" +
                  i +
                  "," +
                  this.IdNodeSelected
              )
              .subscribe((data2) => {
                var text = this.txtFrancais;
                if (i == 1) text = this.txtAnglais;

                if (data2.length > 0) {
                  this.generalService.modifierLanguage(data2[0].Lg_Id, text);
                } else {
                  this.generalService.enregistrerLanguage(
                    this.IdNodeSelected,
                    i,
                    text
                  );
                }
              });
          }
        } else {
          this.generalService.dialogSuccess(
            "veuillez sélectionner un element",
            false
          );
        }
      } else
        this.generalService.dialogSuccess(
          "Veuillez entrer les différentes langues",
          false
        );
    } catch {}
  }
}
